import { MuiMessages, TranslationMuiMessages } from "../interfaces/muiMessages";

export const messages: TranslationMuiMessages = {
  [MuiMessages.autocompleteLoading]: "Loading...",
  [MuiMessages.autocompleteNoOptions]: "No options"
};
